export default class FileFormModal {
    /**
     * 
     * @param {string} options.title
     * @param {string} options.fileName
     * @param {string} options.fileLabel
     * @param {string} options.url
     * @param {string} options.onSuccess
     */
    constructor(options) {
        let myself = this;
        this.dialog = bootbox.dialog({
            title: options.title,
            message: '<i class="fas fa-spin fa-spinner"></i> cargando',
            buttons: {
                cancel: {
                    label: 'Cancelar',
                    className: 'btn-danger'
                },
                ok: {
                    label: 'Registrar',
                    className: 'btn-primary',
                    callback: function() {
                        let jqform = myself.dialog.find('form');
                        jqform.submit();
                        return false;
                    }
                }
            }
        });
        this.dialog.init(function() {
            myself.dialog.find('.bootbox-body').html(`<form>
            <div class="row form-group">
                <label for="${options.fileName}" class="col-form-label col-12">${options.fileLabel}</label>
                <div class="col-12">
                    <input type="file" id="${options.fileName}" name="${options.fileName}" class="form-control" required/>
                </div>
            </div>
            </form>`);
            let jqform = myself.dialog.find('form');
            jqform.validate({
                submitHandler: function(form) {
                    let dataForm = new FormData();
                    dataForm.append(options.fileName, form.querySelector('input').files[0]);
                    Ajax.put(options.url, dataForm, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        then: function(response) {
                            if (options.onSuccess !== undefined) {
                                options.onSuccess(response);
                            }
                            myself.dialog.modal('hide');
                        }
                    });
                }
            });
        });
    }
}